// extracted by mini-css-extract-plugin
export default {"Blankslate":"archive-empty-states-module__Blankslate--hDp6h","Octicon":"archive-empty-states-module__Octicon--WAfE9"};